// extracted by mini-css-extract-plugin
module.exports = {"opportunity":"_142b4d0"};